webpackJsonp([1],Array(73).concat([
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var cartItems = [];

var getCartItems = function getCartItems() {
  return cartItems;
};

var addToCart = function addToCart(item) {
  var itemInCart = cartItems.find(function (currentItem) {
    return item.id === currentItem.id;
  });
  if (itemInCart) {
    console.log('itemInCart', itemInCart);
    itemInCart.quantity++;
  } else {
    item.quantity = 1;
    cartItems.push(item);
  }
};

var substractFromCart = function substractFromCart(itemId) {
  var itemIndex = cartItems.findIndex(function (item) {
    return item.id === itemId;
  });
  if (itemIndex > -1) {
    if (cartItems[itemIndex].quantity > 1) {
      cartItems[itemIndex].quantity--;
    } else {
      cartItems.splice(itemIndex, 1);
    }
  }
};

var clearItem = function clearItem(itemId) {
  var itemIndex = cartItems.findIndex(function (item) {
    return item.id === itemId;
  });
  if (itemIndex > -1) {
    cartItems.splice(itemIndex, 1);
  }
};

var getCartTotal = function getCartTotal() {
  return cartItems.reduce(function (acc, item) {
    return acc + item.quantity * item.price;
  }, 0);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  substractFromCart: substractFromCart,
  getCartItems: getCartItems,
  clearItem: clearItem,
  addToCart: addToCart,
  getCartTotal: getCartTotal
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_books_BookList__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_books_BookList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_books_BookList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_email_EmailApp__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_email_EmailApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_email_EmailApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_places_PlaceApp__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_places_PlaceApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_places_PlaceApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_about__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_main_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_main_about__);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  components: {
    EmailApp: __WEBPACK_IMPORTED_MODULE_4__components_email_EmailApp___default.a
  },
  routes: [{
    path: '/',
    name: 'hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/book-list',
    name: 'book-list',
    component: __WEBPACK_IMPORTED_MODULE_3__components_books_BookList___default.a
  }, {
    path: '/email',
    name: 'email',
    component: __WEBPACK_IMPORTED_MODULE_4__components_email_EmailApp___default.a

  }, {
    path: '/place',
    name: 'place',
    component: __WEBPACK_IMPORTED_MODULE_5__components_places_PlaceApp___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_6__components_main_about___default.a
  }]
}));

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(295),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_AppBar__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_main_AppBar__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    AppBar: __WEBPACK_IMPORTED_MODULE_0__components_main_AppBar___default.a
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'book-details',
    props: ['book'],
    methods: {
        closeMe: function closeMe() {
            console.log('close me!');
            this.$emit('close');
        },
        requestNextBook: function requestNextBook() {
            console.log('Requesting Next');
            this.$emit('next');
        }
    }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'book-edit',
    props: ['book'],

    data: function data() {
        return {
            bookToEdit: null
        };
    },
    created: function created() {
        this.bookToEdit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.book);
    },

    methods: {
        save: function save() {
            console.log('Saving', this.bookToEdit);
            this.$emit('save', this.bookToEdit);
        },
        cancel: function cancel() {
            this.$emit('delete');
        }
    }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'book-filter',
    data: function data() {
        return {
            bookFilter: { byText: '', byMaxPrice: 1000 }
        };
    },
    created: function created() {
        this.$watch('bookFilter.byText', function (newVal, oldVal) {
            this.$emit('set-filter', this.bookFilter);
        });
    },

    methods: {}
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_book_service_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_cart_service_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookEdit__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BookEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BookDetails__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BookDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BookDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BookPreview__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BookPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BookPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BookFilter__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BookFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BookFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Cart__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Cart__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'book-list',

    components: {
        BookEdit: __WEBPACK_IMPORTED_MODULE_2__BookEdit___default.a, BookDetails: __WEBPACK_IMPORTED_MODULE_3__BookDetails___default.a, BookPreview: __WEBPACK_IMPORTED_MODULE_4__BookPreview___default.a, BookFilter: __WEBPACK_IMPORTED_MODULE_5__BookFilter___default.a, Cart: __WEBPACK_IMPORTED_MODULE_6__Cart___default.a
    },

    data: function data() {
        return {
            books: null,
            selectedBook: null,
            editedBook: null,
            isCreateMode: false,
            bookFilter: null
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__services_book_service_js__["a" /* default */].getBooks().then(function (books) {
            _this.books = books;
        });
    },

    computed: {
        booksToShow: function booksToShow() {
            var _this2 = this;

            if (!this.bookFilter) return this.books;
            return this.books.filter(function (book) {
                return book.name.includes(_this2.bookFilter.byText);
            });
        }
    },
    methods: {
        selectBook: function selectBook(book) {
            this.selectedBook = book;
        },
        resetSelected: function resetSelected() {
            this.selectedBook = null;
        },
        selectNext: function selectNext() {
            this.selectedBook = __WEBPACK_IMPORTED_MODULE_0__services_book_service_js__["a" /* default */].getNext(this.selectedBook);
        },
        editBook: function editBook(book) {
            this.editedBook = book;
        },
        deleteBook: function deleteBook(book) {
            __WEBPACK_IMPORTED_MODULE_0__services_book_service_js__["a" /* default */].deleteBook(book);
        },
        saveBook: function saveBook(book) {
            __WEBPACK_IMPORTED_MODULE_0__services_book_service_js__["a" /* default */].saveBook(book);
            this.editedBook = null;
            this.isCreateMode = false;
        },
        setFilter: function setFilter(newFilter) {
            console.log('newFilter', newFilter);
            this.bookFilter = newFilter;
        },
        addToCart: function addToCart(book) {
            __WEBPACK_IMPORTED_MODULE_1__services_cart_service_js__["a" /* default */].addToCart(book);
        }
    }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'book-preview',
    props: ['book'],
    methods: {
        editBook: function editBook() {
            this.$emit('edit');
        },
        deleteBook: function deleteBook() {
            this.$emit('delete');
        },
        addToCart: function addToCart() {
            this.$emit('add-to-cart');
        }
    }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_cart_service_js__ = __webpack_require__(73);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'cart',
    data: function data() {
        return {
            items: __WEBPACK_IMPORTED_MODULE_0__services_cart_service_js__["a" /* default */].getCartItems()
        };
    },

    computed: {
        total: function total() {
            this.items;
            return __WEBPACK_IMPORTED_MODULE_0__services_cart_service_js__["a" /* default */].getCartTotal();
        }
    }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailList__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EmailList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailDetails__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EmailDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmailStatus__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmailStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EmailStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmailCompose__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmailCompose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__EmailCompose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_email_service_js__ = __webpack_require__(161);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Email',
  components: { EmailList: __WEBPACK_IMPORTED_MODULE_1__EmailList___default.a, EmailDetails: __WEBPACK_IMPORTED_MODULE_2__EmailDetails___default.a, EmailStatus: __WEBPACK_IMPORTED_MODULE_3__EmailStatus___default.a, EmailCompose: __WEBPACK_IMPORTED_MODULE_4__EmailCompose___default.a },
  data: function data() {
    return {
      emails: [],
      selectedEmail: null,
      isComposing: false
    };
  },


  methods: {
    selectEmail: function selectEmail(email) {
      this.selectedEmail = email;
      this.isComposing = false;
    },
    deleteEmail: function deleteEmail(emailToDel) {
      var _this = this;

      var tempMailId = null;
      var emailsProp = __WEBPACK_IMPORTED_MODULE_5__services_email_service_js__["a" /* default */].deleteEmail(this.selectedEmail, this.emails);
      this.emails.splice(this.emails.findIndex(function (email) {
        return email === _this.selectedEmail;
      }), 1);
      this.selectedEmail = null;
      emailsProp.then(function (answer) {
        _this.emails = answer.emails;
        console.log(answer.selectedEmailIdx);
        if (answer.selectedEmailIdx !== null) _this.selectedEmail = _this.emails[answer.selectedEmailIdx];
      });
    },
    composeEmail: function composeEmail() {
      this.isComposing = true;
    },
    sendEmail: function sendEmail(subject, body) {
      var id = +this.getLastEmailId() + 1;
      console.log(id);
      this.emails.push({ subject: subject, body: body, isRead: false, id: id });
      __WEBPACK_IMPORTED_MODULE_5__services_email_service_js__["a" /* default */].sendNewMail(this.emails);
    },
    getLastEmailId: function getLastEmailId() {
      var id;
      var idx = this.emails.length - 1;

      try {
        id = this.emails[idx].id;
      } catch (e) {
        id = 0;
      }
      return id;
    }
  },
  created: function created() {
    var _this2 = this;

    var newEmails = __WEBPACK_IMPORTED_MODULE_5__services_email_service_js__["a" /* default */].getEmails();
    newEmails.then(function (prmEmails) {
      _this2.emails = prmEmails;
      _this2.selectedEmail = _this2.emails[0];
      _this2.emails[0].isRead = true;
    });
    console.log("created");
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'email-compose',
  data: function data() {
    return {
      subject: null,
      body: null
    };
  },

  methods: {
    sendEmail: function sendEmail() {
      this.$emit('emailSent', this.subject, this.body);
      this.body = null;
      this.subject = null;
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'email-details',
  props: ['email'],
  methods: {
    deleteEmail: function deleteEmail() {
      console.log("delete button pushed");
      this.$emit('delete');
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'email-filter',
  data: function data() {
    return {
      onInput: '',
      onStatusChange: ''
    };
  },

  watch: {
    onInput: function onInput(newVal) {
      this.$emit('filterChanged', newVal);
    },
    onStatusChange: function onStatusChange(newVal) {
      console.log(" newVal:" + newVal);
      this.$emit('statusChanged', newVal);
    }
  },
  methods: {}
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmailPreview__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmailPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EmailPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailFilter__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EmailFilter__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: { EmailPreview: __WEBPACK_IMPORTED_MODULE_0__EmailPreview___default.a, EmailFilter: __WEBPACK_IMPORTED_MODULE_1__EmailFilter___default.a },
    name: 'email-list',
    props: ['emails', 'selectedEmail'],
    data: function data() {
        return {
            emailsToRender: this.emails,
            gFilterVar: '',
            gStatusFilter: 'all'
        };
    },

    methods: {
        getEmailIdx: function getEmailIdx(row, emailInQuestion) {
            var idx = null;
            this.emails.forEach(function (email, index) {
                if (email === emailInQuestion) {
                    idx = index;
                }
            });
            return idx;
        },
        selectEmail: function selectEmail(email) {
            console.log(email);
            email.isRead = true;
            this.$emit('selectAnotherMail', email);
        },
        renderRelevantTxt: function renderRelevantTxt(filterVal) {
            this.gFilterVar = filterVal;
        },
        renderRelevantStatus: function renderRelevantStatus(filterVal) {
            this.gStatusFilter = filterVal;
            console.log('renderRelevatnStatus');
        },
        filterEmail: function filterEmail() {
            var _this = this;

            return this.emailsToRender = this.emails.filter(function (email) {
                return email.subject.toLowerCase().includes(_this.gFilterVar.toLowerCase()) && (_this.gStatusFilter === 'all' || _this.gStatusFilter === 'read' && email.isRead || _this.gStatusFilter === 'unread' && !email.isRead);
            });
        }
    },
    computed: {
        getEmails: function getEmails() {
            return this.filterEmail();
        }
    }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'email-preview',
  props: ['email'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_ProgressBar__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__general_ProgressBar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'email-status',
  props: ['emails'],
  components: { ProgressBar: __WEBPACK_IMPORTED_MODULE_1__general_ProgressBar___default.a },
  computed: {
    generatePercantage: function generatePercantage() {
      var readCount = 0;
      var percantage;
      this.emails.forEach(function (email) {
        if (email.isRead) {
          readCount++;
        }
      });
      percantage = readCount / (this.emails.length / 100);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(percantage)) percantage = 0;
      return Math.round(percantage);
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'progress-bar',
  props: ['percentage'],
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'appbar',
  data: function data() {
    return {
      msg: 'Welcome to Appsus'
    };
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Place',
  data: function data() {
    return {
      center: { lat: 10.0, lng: 10.0 },
      markers: [],
      infoContent: '',
      infoOptions: { pixelOffset: { width: 0, height: -35 } },
      infoWinOpen: false,
      infoWindowPos: { lat: 0, lng: 0 }
    };
  },


  methods: {
    addMarker: function addMarker(event) {
      var marker = {
        position: { lat: event.latLng.lat(), lng: event.latLng.lng() },
        infoText: 'Add your place name here'
      };
      this.markers.push(marker);
      this.$http.post('/add_marker/', marker).then(function (response) {});
    },
    hello: function hello() {
      this.$router.push({ name: 'hello' });
    },
    toggleInfoWindow: function toggleInfoWindow(marker, index) {
      this.center = marker.position;
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;

      if (this.currentMidx == index) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
          this.infoWinOpen = true;
          this.currentMidx = index;
        }
    },
    infoOpened: function infoOpened(event) {
      var that = this;
      this.$el.querySelector(".gm-style-iw").addEventListener("click", function (ev) {
        if (ev.target.name != "") {
          var element = ev.target;
          var text = element.textContent;
          var input = document.createElement("input");
          input.setAttribute("value", text);
          input.addEventListener("keyup", function (event) {
            event.preventDefault();
            if (event.keyCode == 13) {
              var inp = event.target;
              that.infoContent = inp.value;
              inp.parentElement.removeChild(inp);
            }
          });
          if (element.parentElement) {
            element.parentElement.appendChild(input);
            element.parentElement.removeChild(element);
          }
          ev.target.removeEventListener("click", this);
        }
      });
    },
    infoChanged: function infoChanged(event) {
      var _this = this;

      var info = this.$el.querySelector(".gm-style-iw");
      if (info) {
        var text = info.firstChild.textContent;
        for (var i = 0; i < this.markers.length; i++) {
          if (this.markers[i].position.lat == this.center.lat && this.markers[i].position.lng == this.center.lng) {
            this.$http.put('/edit_marker/', { marker: this.markers[i], new_text: text }).then(function (response) {
              _this.markers[i].infoText = text;
            });
            break;
          }
        }
      }
    },
    deleteMarker: function deleteMarker(event) {
      var _this2 = this;

      for (var i = 0; i < this.markers.length; i++) {
        if (this.markers[i].position.lat == this.center.lat && this.markers[i].position.lng == this.center.lng) {
          this.$http.delete('/delete_marker/', { body: this.markers[i] }).then(function (response) {
            _this2.infoWinOpen = false;
            _this2.markers.splice(i, 1);
          });
          break;
        }
      }
    }
  },
  computed: {
    getMarkers: function getMarkers() {
      return this.markers;
    },
    getCenter: function getCenter() {
      var that = this;
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(function (position) {
          that.center = { lat: position.coords.latitude, lng: position.coords.longitude };
          return that.center;
        });
      }
      return this.center;
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('/get_markers/').then(function (response) {
      _this3.markers = response.body;
    });
  }
});

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__, {
  load: {
    key: 'AIzaSyCc_X_TBp3vs4y4oWiEcRrHpwilGYJWNEY'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var books = [];

function getBooks() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    if (books.length) {
      resolve(books);
    } else {
      setTimeout(function () {
        books = generateBooks();

        books = books.map(function (book) {
          book.quantity = 0;
          book.tag = { val: 7 };
          return book;
        });
        resolve(books);
      }, 500);
    }
  });
}

function getBookById(bookId) {
  return getBooks().then(function (books) {
    var book = books.find(function (book) {
      return bookId === book.id;
    });
    return book;
  });
}

function deleteBook(book) {
  console.log('Deleting the book', book);
  var idx = books.indexOf(book);
  books.splice(idx, 1);
}

function getNext(book) {
  var idx = books.indexOf(book);
  return idx < books.length - 1 ? books[idx + 1] : books[0];
}

function saveBook(book) {
  var idx = books.findIndex(function (currBook) {
    return currBook.id === book.id;
  });
  if (idx > -1) {
    books.splice(idx, 1, book);
  } else {
    books.push(book);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getBooks: getBooks,
  deleteBook: deleteBook,
  getNext: getNext,
  saveBook: saveBook
});

function generateBooks() {
  return [{ id: 1, name: 'The Little Prince', desc: 'bla bla', price: 200, author: 'Antoine de Saint Exupéry', imgUrl: 'http://www.lookingglassreview.com/assets/images/The_Little_Prince.jpg' }, { id: 2, name: 'War and Peace', desc: 'bla bla', price: 100, author: 'Leo Tolstoy', imgUrl: 'http://fivebooks.com//app/uploads/2012/04/1400079985.01.LZ_1.jpg' }, { id: 3, name: 'Harry Potter', desc: 'bla bla', price: 150, author: 'J. K. Rowling', imgUrl: 'http://img.yumpu.com/55880836/1/358x471/07-harry-potter-y-las-reliquias-de-la-muerte.jpg?quality=80' }, { id: 4, name: 'Lolita', desc: 'bla bla', price: 120, author: 'Nabokov', imgUrl: 'https://vdarcangelo.files.wordpress.com/2011/07/lolita-book-cover.jpg?w=187&h=300' }];
}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);


var urlEmail = 'http://localhost:3003';
function deleteEmail(selectedEmail, emails) {
  return __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
    url: urlEmail + '/emails/' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(selectedEmail),
    type: 'DELETE',

    success: function success(result) {}
  }).then(function (answer) {
    return answer;
  });
}
function getEmails() {
  var prmEmails = fetch(urlEmail + '/emails');
  var emails = null;
  return prmEmails.then(function (res) {
    return res.json();
  }).then(function (email) {
    return email;
  });
}
function sendNewMail(newMails) {
  console.log('posting');
  return __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
    url: urlEmail + '/emails/' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newMails),
    type: 'POST'
  }).then(function (answer) {
    return answer;
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteEmail: deleteEmail,
  getEmails: getEmails,
  sendNewMail: sendNewMail
});

/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Book.5d05dd4.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/efim.d8c8a00.jpg";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/email.3ef3613.png";

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lora.bc32cf4.jpg";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/maps.bef0f48.png";

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(282),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(286),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(290),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(293),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(292),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(285),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(280),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(288),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(224)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(277),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-114e1a89",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(299),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fb7f91a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(289),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(294),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(276),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(231)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(287),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(228)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(283),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(291),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-89f36b4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(226)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(279),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1976ac88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(284),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(281),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(296),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d00e718a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(298),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f3577b98",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(278),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17b039f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "compose"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "Subject:"
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 37,
        maxRows: 70
      },
      "placeholder": "Text:"
    },
    model: {
      value: (_vm.body),
      callback: function($$v) {
        _vm.body = $$v
      },
      expression: "body"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-dark"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("Send")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.books) ? _c('section', [_c('div', {
    staticClass: "cart"
  }, [_c('Cart')], 1), _vm._v(" "), _c('BookFilter', {
    on: {
      "set-filter": _vm.setFilter
    }
  }), _vm._v(" "), _c('h2', [_vm._v("We have " + _vm._s(_vm.books.length) + " Books")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.isCreateMode = true
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('ul', _vm._l((_vm.booksToShow), function(currBook) {
    return _c('book-preview', {
      key: currBook.id,
      attrs: {
        "book": currBook
      },
      on: {
        "edit": function($event) {
          _vm.editBook(currBook)
        },
        "delete": function($event) {
          _vm.deleteBook(currBook)
        },
        "add-to-cart": function($event) {
          _vm.addToCart(currBook)
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectBook(currBook)
        }
      }
    })
  })), _vm._v(" "), (_vm.selectedBook) ? _c('BookDetails', {
    attrs: {
      "book": _vm.selectedBook
    },
    on: {
      "close": _vm.resetSelected,
      "next": _vm.selectNext
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editedBook || _vm.isCreateMode) ? _c('BookEdit', {
    attrs: {
      "book": _vm.editedBook
    },
    on: {
      "save": _vm.saveBook,
      "delete": function($event) {
        _vm.editedBook = null;
        _vm.isCreateMode = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('section', {
    staticClass: "map"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "800px",
      "height": "450px"
    },
    attrs: {
      "center": _vm.getCenter,
      "zoom": 7,
      "map-type-id": "terrain"
    },
    on: {
      "rightclick": _vm.addMarker
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "domready": _vm.infoOpened,
      "content_changed": _vm.infoChanged,
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.getMarkers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "clickable": true,
        "position": m.position
      },
      on: {
        "click": function($event) {
          _vm.toggleInfoWindow(m, index)
        }
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "delete"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.deleteMarker
    }
  }, [_vm._v("Delete")])], 1), _vm._v(" "), _c('div', {
    staticClass: "instruction"
  }, [_c('el-collapse', [_c('el-collapse-item', {
    attrs: {
      "title": "Instruction",
      "name": "1"
    }
  }, [_c('h3', [_vm._v("\r\n               1) Rightclick on map to marker some place. \r\n            ")]), _vm._v(" "), _c('h3', [_vm._v("\r\n               2) Click on input write something. \r\n            ")]), _vm._v(" "), _c('h3', [_vm._v("\r\n               3) Click Enter to save text in input.\r\n            ")]), _vm._v(" "), _c('h3', [_vm._v("\r\n              4) Delete marker on map need to click on marker and after click on button botom - delete.\r\n            ")])])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('li', {
    class: {
      read: _vm.email.isRead
    }
  }, [_vm._v(_vm._s(_vm.email.subject))])])
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "popup book-edit"
  }, [(_vm.book) ? _c('h1', [_vm._v("Edit: " + _vm._s(_vm.book.name))]) : _c('h1', [_vm._v("New Book")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookToEdit.name),
      expression: "bookToEdit.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bookToEdit.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookToEdit.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.percentage !== 100) ? _c('el-progress', {
    attrs: {
      "percentage": _vm.percentage,
      "status": "danger"
    }
  }) : _c('el-progress', {
    attrs: {
      "percentage": _vm.percentage,
      "status": "success"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter"
  }, [_c('div', [_c('el-input', {
    attrs: {
      "placeholder": "search",
      "icon": "search"
    },
    model: {
      value: (_vm.onInput),
      callback: function($$v) {
        _vm.onInput = $$v
      },
      expression: "onInput"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "name": "emailStatus",
      "label": "all",
      "checked": ""
    },
    model: {
      value: (_vm.onStatusChange),
      callback: function($$v) {
        _vm.onStatusChange = $$v
      },
      expression: "onStatusChange"
    }
  }, [_vm._v(" All")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "name": "emailStatus",
      "label": "read"
    },
    model: {
      value: (_vm.onStatusChange),
      callback: function($$v) {
        _vm.onStatusChange = $$v
      },
      expression: "onStatusChange"
    }
  }, [_vm._v(" Read")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "name": "emailStatus",
      "label": "unread"
    },
    model: {
      value: (_vm.onStatusChange),
      callback: function($$v) {
        _vm.onStatusChange = $$v
      },
      expression: "onStatusChange"
    }
  }, [_vm._v(" Unread")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('progress-bar', {
    attrs: {
      "percentage": _vm.generatePercantage
    }
  })
},staticRenderFns: []}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "popup book-details"
  }, [_c('button', {
    on: {
      "click": _vm.closeMe
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('h1', [_vm._v("Details of: " + _vm._s(_vm.book.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.book.imgUrl
    }
  }), _vm._v(" "), _c('h3', [_vm._v("\\$" + _vm._s(_vm.book.price))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.book.author))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.book.desc))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.requestNextBook
    }
  }, [_vm._v("Next > ")])])
},staticRenderFns: []}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-email"
  }, [(_vm.email) ? _c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.email.body))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-dark"
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "delete",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.deleteEmail()
      }
    }
  }, [_vm._v("Delete")])], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "book-filter"
  }, [_c('h2', [_vm._v("Books Filter")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookFilter.byText),
      expression: "bookFilter.byText"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Filter By Name"
    },
    domProps: {
      "value": (_vm.bookFilter.byText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookFilter.byText = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "cart"
  }, [_c('h1', [_vm._v("Books")]), _vm._v(" "), _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', [_vm._v("\n            " + _vm._s(item.name) + " (Quantity: " + _vm._s(item.quantity) + ")\n            "), _c('p', [_vm._v("TAG: " + _vm._s(item.tag))])])
  })), _vm._v(" "), _c('p', [_vm._v("Total: " + _vm._s(_vm.total))])])
},staticRenderFns: []}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('email-filter', {
    on: {
      "filterChanged": _vm.renderRelevantTxt,
      "statusChanged": _vm.renderRelevantStatus
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.getEmails
    },
    on: {
      "row-click": _vm.selectEmail
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "subject",
      "label": "Subject",
      "width": "500"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  })
},staticRenderFns: []}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-app"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "emails"
  }, [_c('email-list', {
    staticClass: "email-list",
    attrs: {
      "emails": _vm.emails,
      "selectedEmail": _vm.selectedEmail
    },
    on: {
      "selectAnotherMail": _vm.selectEmail
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "email-inner"
  }, [(!_vm.isComposing) ? _c('email-details', {
    attrs: {
      "email": _vm.selectedEmail
    },
    on: {
      "delete": function($event) {
        _vm.deleteEmail(_vm.selectedEmail)
      }
    }
  }) : _c('email-compose', {
    on: {
      "emailSent": _vm.sendEmail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "com"
  }, [_c('el-button', {
    staticClass: "compose",
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.composeEmail
    }
  }, [_vm._v("compose")])], 1)], 1)]), _vm._v(" "), _c('email-status', {
    attrs: {
      "emails": _vm.emails
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "main-nav flex align-center justify-center"
  }, [_c('ul', {
    staticClass: "clean-list flex align-center"
  }, [_c('router-link', {
    staticClass: "active",
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Appsus")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "active",
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("About")])])], 1)]), _vm._v(" "), _c('AppBar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "logo flex align-center justify-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(247),
      "alt": "Company name"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer flex justify-center align-center clean-list"
  }, [_c('li', [_vm._v("© 2017 Coding Academy")])])
}]}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/place"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(249)
    }
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/email"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(246)
    }
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/book-list"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(244)
    }
  })]), _vm._v(" "), _c('hr')], 1)
},staticRenderFns: []}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "post-img-about post-container-about"
  }, [_c('img', {
    staticClass: "img-about",
    attrs: {
      "src": __webpack_require__(245)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('h1', [_vm._v("Efim Rozovsky")]), _vm._v(" "), _c('p', [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam eaque illo quibusdam, consectetur eos facere cum perspiciatis\n          aperiam voluptas inventore nesciunt, assumenda nemo, maiores, deserunt ratione voluptatum sint expedita\n          labore! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam eaque illo quibusdam, consectetur eos facere cum perspiciatis\n          aperiam voluptas inventore nesciunt, assumenda nemo, maiores, deserunt ratione voluptatum sint expedita\n          labore!\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "post-img-about post-container-about"
  }, [_c('img', {
    staticClass: "img-about",
    attrs: {
      "src": __webpack_require__(248)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('h1', [_vm._v("Lora Arshavski")]), _vm._v(" "), _c('p', [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam eaque illo quibusdam, consectetur eos facere cum perspiciatis\n          aperiam voluptas inventore nesciunt, assumenda nemo, maiores, deserunt ratione voluptatum sint expedita\n          labore! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam eaque illo quibusdam, consectetur eos facere cum perspiciatis\n          aperiam voluptas inventore nesciunt, assumenda nemo, maiores, deserunt ratione voluptatum sint expedita\n          labore!\n      ")])])])
}]}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "book-preview"
  }, [_c('h2', [_vm._v(_vm._s(_vm.book.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.book.author))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.book.price))]), _vm._v(" "), _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.book.imgUrl
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editBook($event)
      }
    }
  }, [_vm._v("✎")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteBook($event)
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addToCart($event)
      }
    }
  }, [_vm._v("Add to Cart")])])
},staticRenderFns: []}

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[159]);


// WEBPACK FOOTER //
// static/js/app.ca51c8d9c431a1c2790e.js